module.exports = __webpack_public_path__ + "img/jqxx.068a0798.png";